'use client';

import React from 'react';
import Link from 'next/link';
import Button from '@mui/material/Button';
import { NOT_FOUND_PAGE_ID } from '@/constants/component-id';
import { HOME_PAGE_ROUTER_PATH } from '@/constants/router-path';
import topImage from '@/assets/homepage/top-background.png';

const ErrorPage = (props: { errorCode: number; errorText: string }) => {
  const { errorCode, errorText } = props;

  return (
    <div
      data-id={NOT_FOUND_PAGE_ID}
      className="bg-no-repeat bg-contain flex flex-auto justify-center flex-col"
      style={{
        backgroundImage: `url(${topImage.src})`,
      }}
    >
      <div className="text-center">
        <h1 className="leading-none font-medium text-denim text-[5.5rem]">
          {errorCode}
        </h1>
        <div className="mt-6 text-base font-medium">{errorText}</div>
        <Button
          variant="contained"
          color="primary"
          className="!mt-12 !py-3 !px-8"
          LinkComponent={Link}
          href={HOME_PAGE_ROUTER_PATH}
        >
          返回首页
        </Button>
      </div>
    </div>
  );
};

export default ErrorPage;
